import React from 'react';
import {
  Box,
  Typography,
  Paper,
  alpha,
} from '@mui/material';

interface KeybindsTabProps {
  colors: any;
  glassStyle: any;
}

const KeybindsTab: React.FC<KeybindsTabProps> = ({ colors, glassStyle }) => {
  return (
    <Box>
      <Typography variant="h5" fontWeight={800} color={colors.textPrimary} sx={{ mb: 1 }}>
        Keybinds
      </Typography>
      <Paper elevation={0} sx={{ bgcolor: colors.cardBg, borderRadius: '24px', p: 4, ...glassStyle }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography fontWeight={700} color={colors.textPrimary}>Push to Talk</Typography>
          <Box sx={{ 
            border: `1px solid ${colors.textPrimary}`, 
            borderRadius: '8px', 
            px: 2, 
            py: 0.5, 
            fontWeight: 700, 
            color: colors.textPrimary 
          }}>
            CTRL + V
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography fontWeight={700} color={colors.textPrimary}>Toggle Mute</Typography>
          <Box sx={{ 
            border: `1px solid ${colors.textPrimary}`, 
            borderRadius: '8px', 
            px: 2, 
            py: 0.5, 
            fontWeight: 700, 
            color: colors.textPrimary 
          }}>
            CTRL + SHIFT + M
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default KeybindsTab;